export let licenseMoreDetailsMockData = [
  {
    displayId: "QDJYOPPC58726354",
    stateCode: "AR",
    number: "09876543212345",
    displayStatus: "ACTIVE",
    type: "Dental Hygienist",
    isValid: "true",
    licenseeName: "Test McTesty",
    issueDateUnavailable: "true",
    expirationDate: "2233-11-11",
    processDate: "2025-03-03T11:16:20.178",
    address: {
      state: "AR",
    },
  },
  {
    displayId: "DQZYKFQU22764168",
    stateCode: "AZ",
    number: "0987654321",
    displayStatus: "PROBATION",
    type: "DENTIST LICENSE",
    isValid: "true",
    licenseeName: "Test McTesty",
    issueDate: "1111-11-18",
    issueDateUnavailable: "false",
    expirationDate: "2222-11-11",
    processDate: "2025-03-03T11:15:35.377",
    address: {
      state: "AZ",
    },
  },
  {
    displayId: "UTQCDAWV57245666",
    stateCode: "CT",
    number: "0987654321",
    displayStatus: "PROBATION",
    type: "Dentist",
    isValid: "true",
    licenseeName: "Test McTesty",
    issueDateUnavailable: "true",
    issueDate: "3232-12-12",
    expirationDate: "1111-11-18",
    processDate: "2025-03-04T14:58:36.165",
    address: {
      state: "CT",
    },
  },
  {
    displayId: "YPUHJHWS29688743",
    stateCode: "IA",
    number: "09876543213",
    displayStatus: "INACTIVE",
    type: "RESIDENT",
    isValid: "true",
    issueDate: "3232-11-12",
    licenseeName: "Test McTesty",
    issueDateUnavailable: "false",
    expirationDate: "2211-11-11",
    processDate: "2025-03-04T15:02:57.447",
    address: {
      state: "IA",
    },
  },
];

export let disciplinaryMoreDetailsMockData = [
  // {
  //   displayId: "NXPSNOEY84504767",
  //   actionDate: "2020-11-22",
  //   description: "New Desc",
  //   status: "WAIVED",
  //   reviewUser: "udayraj.n@evernorth.com",
  //   note: "New Desc",
  // },
  // {
  //   // displayId: "BFXWNVXA44329431", // since this filter is happening from backend used different displayId
  //   displayId: "QDJYOPPC58726354",
  //   actionDate: "3333-11-22",
  //   description: "something",
  //   status: "WAIVED",
  //   reviewUser: "udayraj.n@evernorth.com",
  //   note: "notes",
  // },
  // {
  //   displayId: "DQZYKFQU22764168", // since this filter is happening from backend used different displayId
  //   actionDate: "5679-01-03",
  //   description: "sadsadsa",
  //   status: "PERMANENT",
  //   reviewUser: "udayraj.n@evernorth.com",
  //   note: "cs afsdf afasff",
  // },
];
